(() => {
  if (customElements.get('saho-payment-brands')) return;
  customElements.define('saho-payment-brands', class extends HTMLElement {
    connectedCallback() { this.attempts = 0; this.mount(); }
    mount() {
      if (!this.isConnected) return;
      const root = this.querySelector('shopify-payment-terms')?.shadowRoot;
      if (!root) {
        if (++this.attempts < 100) this.timer = setTimeout(() => this.mount(), 100);
        return;
      }
      this.root = root;
      this.sync();
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(root, {childList: true, subtree: true});
    }
    sync() {
      const paragraph = this.root.querySelector('#shopify-installments');
      const cta = this.root.querySelector('#shopify-installments-cta');
      if (!paragraph || !cta) return;
      if (!this.root.querySelector('[data-saho-payment-style]')) {
        const style = document.createElement('style');
        style.dataset.sahoPaymentStyle = '';
        style.textContent = `
          #shopify-installments{color:#666}
          #shopify-installments-content > div{color:#666!important}
          .saho-payment-comma{white-space:nowrap;color:inherit}
          .saho-inline-brands{margin-inline-start:4px;display:inline-flex;align-items:center;gap:5px;vertical-align:middle;white-space:nowrap;color:#666}
          .saho-afterpay-logo{display:block;height:18px;width:auto;max-width:none;filter:grayscale(1);opacity:.65}
          .saho-klarna-logo{display:inline-flex;align-items:center}
          .saho-klarna-logo svg{display:block;width:41px;height:12.5px}
          .saho-klarna-logo path{fill:#666}
          @media(max-width:749px){
            #shopify-installments{font-size:11px}
            .saho-inline-brands{gap:3px}
            .saho-afterpay-logo{height:18px}
            .saho-klarna-logo svg{width:41px;height:12.5px}
          }
        `;
        this.root.append(style);
      }
      if (!paragraph.querySelector('.saho-payment-comma')) {
        const comma = document.createElement('span');
        comma.className = 'saho-payment-comma';
        comma.textContent = '\u2060,';
        cta.after(comma);
      }
      if (!paragraph.querySelector('.saho-inline-brands')) {
        const source = this.querySelector('template[data-payment-brands]');
        if (!source) return;
        const fragment = source.content.cloneNode(true);
        const klarna = fragment.querySelector('.saho-klarna-logo svg');
        if (klarna) {
          klarna.setAttribute('viewBox', '4 8 30 9');
          klarna.querySelectorAll('rect').forEach(rect => rect.remove());
        }
        paragraph.append(fragment);
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); }
  });
})();